var _a;
import Sliders from '../components/swiper-init';
import { funcyInit } from '../components/funcy-init';
const initBlockExample = () => {
    Sliders.initSwiperRightAndLeft('.js-gallery-left');
    Sliders.initSwiperRightAndLeft('.js-footer-left');
    funcyInit();
};
document.addEventListener('DOMContentLoaded', initBlockExample, false);
if (window['acf']) {
    (_a = window['acf']) === null || _a === void 0 ? void 0 : _a.addAction('render_block_preview', initBlockExample);
}
